import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { timerSelector } from '../selectors/wizardSelectors';
import { decreaseTimer } from '../actions/wizardActions';
import CircularLoader from '../../shared/components/CircularLoader/CircularLoader';

const mapStateToProps = createStructuredSelector({ timer: timerSelector });
const mapDispatchToProps = { decreaseTimer };

export default connect(mapStateToProps, mapDispatchToProps)(CircularLoader);
